module.exports = __webpack_public_path__ + "static/media/calendar-restaurant.e8da9762.svg";